/* TYB buyer audit fixes, Oct 21 2026.
   A) Hide the floating 20% tab (shopify-forms-embed) and Chat bubble (shopify-chat) only while
      they would cover something the buyer needs. They come back as soon as that ends.
   B) Stop a tap on an already-selected option in a REQUIRED Easify group from clearing it. */
(() => {
  'use strict';
  const HIDE = 'tyb-floaters-hidden';
  const phone = window.matchMedia('(max-width: 989px)');
  const FIELD = 'input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button]), textarea, select';
  const ZONES = [
    '.easify-product-options',            // product options + validation messages
    '.cart__foot', '.cart__footer', 'form.cart__inner .cart__total', '[data-cart-form] .cart__foot',
    'main [name=checkout]', 'main .cart__total', 'main .cart__message',  // cart page checkout + note
    '.tyb-unit-sales__submit',            // Team / Unit form send button
    'form.contact-form button[type=submit]',
    '.footer-sections form',              // footer newsletter JOIN
  ].join(',');

  const inView = (el) => {
    const r = el.getBoundingClientRect();
    if (r.width < 1 || r.height < 1) return false;
    // Options block: only counts once it shows more than a sliver (so the tab/chat still appear on page load
    // when the options just peek in at the bottom edge). Buttons/forms count as soon as they enter.
    const edge = el.matches && el.matches('.easify-product-options') ? 140 : 0;
    return r.bottom > 0 && r.top < window.innerHeight - edge;
  };

  const drawerOpen = () => !!document.querySelector('cart-drawer.is-open, .drawer--cart.is-open');

  const typing = () => {
    const a = document.activeElement;
    if (!a || a === document.body) return false;
    if (a.closest && a.closest('shopify-forms-embed, shopify-chat')) return false;
    return a.matches && a.matches(FIELD);
  };

  const zoneVisible = () => {
    if (!phone.matches) return false;
    const els = document.querySelectorAll(ZONES);
    for (let i = 0; i < els.length; i++) {
      if (els[i].closest('cart-drawer') && !drawerOpen()) continue;
      if (inView(els[i])) return true;
    }
    return false;
  };

  let queued = false;
  const update = () => {
    queued = false;
    if (!document.body) return;
    const hide = drawerOpen() || typing() || zoneVisible();
    document.body.classList.toggle(HIDE, hide);
  };
  const schedule = () => { if (!queued) { queued = true; window.requestAnimationFrame(update); } };

  ['scroll', 'resize', 'focusin', 'focusout', 'click', 'touchend'].forEach((ev) =>
    window.addEventListener(ev, () => { schedule(); setTimeout(schedule, 350); }, { passive: true, capture: true })
  );
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
  document.addEventListener('theme:drawer:open', schedule);
  document.addEventListener('theme:drawer:close', schedule);

  const start = () => {
    schedule();
    [300, 1000, 2500, 5000].forEach((d) => setTimeout(schedule, d));
    const mo = new MutationObserver(schedule);
    mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  /* B) Required single-choice Easify groups: tapping the selected choice again used to clear it. */
  const guard = (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const root = t.closest('.easify-product-options .po-option-root');
    if (!root) return;
    const required = !!root.querySelector(':scope .po-label-required');
    if (!required) return;
    const own = (sel) => Array.from(root.querySelectorAll(sel)).filter((x) => x.closest('.po-option-root') === root);
    // Image swatch
    const sw = t.closest('.po-imageOption-swatchLabel, .po-imageSwatches-optionItem');
    if (sw) {
      const item = sw.closest('.po-imageSwatches-optionItem') || sw;
      const checked = own('.po-imageOption-checked');
      if (checked.length === 1 && item.contains(checked[0])) { e.preventDefault(); e.stopImmediatePropagation(); }
      return;
    }
    // Button option
    const btn = t.closest('.po-buttonOption-content');
    if (btn) {
      const outer = t.closest('.po-optionItem-item');
      const selected = own('.po-buttonOption-content.po-buttonOption-selected');
      if (selected.length === 1 && outer && outer.contains(selected[0])) { e.preventDefault(); e.stopImmediatePropagation(); }
    }
  };
  document.addEventListener('click', guard, true);
})();
